import { NgModule } from "@angular/core";
import { FileUploadComponent } from "./file-upload.component";
import { FileSizePipeModule } from '@app/file-size.module';
import { CommonModule } from '@angular/common';
import { FormsModule } from "@angular/forms";



@NgModule({
  declarations: [FileUploadComponent],
  exports: [FileUploadComponent],
	imports:[FileSizePipeModule,CommonModule,FormsModule]
})
export class FileUploadModule {}